import { Link } from "react-router-dom";
import SubscriptionPathsSummary from "components/client/SubscriptionPathsSummary";
import { readClientSession } from "utils/clientSession";

export default function Subscription() {
  const session = readClientSession();

  return (
    <div className="space-y-6">
      <div className="rounded-[20px] border border-gray-200 bg-white p-6 shadow-sm dark:border-white/10 dark:bg-navy-800">
        <h2 className="text-xl font-bold text-navy-700 dark:text-white">
          Subscription
        </h2>
        <p className="mt-2 text-sm text-gray-600 dark:text-gray-400">
          Overview of your two subscription paths. Slots, accounts, and
          broker connection are managed separately — open{" "}
          <strong className="text-navy-800 dark:text-white">Manage</strong> on
          each path for add / connect / edit. Copy on/off and risk are on{" "}
          <Link
            to="/client/dashboard"
            className="font-semibold text-brand-500 hover:underline dark:text-brand-300"
          >
            Dashboard
          </Link>
          .
        </p>
      </div>

      <SubscriptionPathsSummary session={session} />
    </div>
  );
}
